<quill-editor
  class="shared-ui-quill-editor block w-full"
  format="html"
  theme="snow"
  [formControl]="internalControl"
  [formats]="quillFormats()"
  [modules]="quillModules()"
  [placeholder]="placeholder()" />
